import React from "react";
import "./LoanDetailsNew.scss";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";

function LoanDetailCardNew({ icon, iconText, title, text1, text2, count }) {
  return (
    <div className="loan-card-new">
      <div className="loan-card-item d-flex">
        <div
          className={`col-4 text-center square ${
            icon ? "blue-background" : "green-background"
          }`}
        >
          {icon ? (
            <AccountBalanceOutlinedIcon sx={{ fontSize: 60, color: "white" }} />
          ) : (
            <p>{count+1}</p>
            // <p>{iconText}</p>
          )}
        </div>
        <div className="col-8 loan-information">
          <div className="loan-title-container">
            <div className="loan-information-title">
              {title}
              {/* <AddCircleOutlinedIcon
                sx={{ color: "#6ebfe5", fontSize: 15, marginLeft: 0.25 }}
              /> */}
            </div>
          </div>
          <div className="loan-information-text">{text1}</div>
          <div className="loan-information-text">{text2}</div>
        </div>
      </div>
    </div>
  );
}

export default LoanDetailCardNew;
